import React from "react";
import "./App.css";
import Header from "./components/Header";
import Product from "./components/Product";
import Footer from "./components/Footer";




let App = () => {
  return (
    <div>
    <Header />
    <Product />
    <Footer />
    
    </div>
    
  );
}

export default App;
